export const PARTNERS = [
  { name: "FIREX", file: "firex" },
  { name: "BARATTA", file: "baratta" },
  { name: "JIPA International", file: "jipa" },
  { name: "Bizerba", file: "bizerba" },
  { name: "GEA", file: "gea" },
  { name: "GASER", file: "gaser" },
  { name: "VELOX", file: "velox" },
  { name: "CARLO MIGLIAVACCA", file: "carlo-migliavacca" },
  { name: "NILMA", file: "nilma" },
  { name: "RÜHLE", file: "ruhle" },
  { name: "ESCHER", file: "escher" },
  { name: "MIWE", file: "miwe" },
  { name: "Aurea", file: "aurea" },
  { name: "Crystal", file: "crystal" },
  { name: "Dadaux", file: "dadaux" },
  { name: "Electrolux", file: "electrolux" },
  { name: "Hallde", file: "hallde" },
  { name: "Hicold", file: "hicold" },
  { name: "Hisakage", file: "hisakage" },
  { name: "Hoshizaki", file: "hoshizaki" },
  { name: "Mareno", file: "mareno" },
  { name: "Rational", file: "rational" },
  { name: "Retigo", file: "retigo" },
  { name: "Wachtel", file: "watchel" },
  { name: "Winterhalter", file: "winterhalter" },
  { name: "CB", file: "cb" },
  { name: "CUPPONE", file: "cuppone" },
  { name: "FINES", file: "fines" },
  { name: "GRAM", file: "gram" },
  { name: "HÄUSSLER", file: "haussler" },
  { name: "IRINOX", file: "irinox" },
  { name: "KENOANDA", file: "kenoanda" },
  { name: "KRUPPS", file: "krupps" },
  { name: "LADETINA", file: "ladetina" },
  { name: "LEHEHE", file: "lehehe" },
  { name: "Life Concept", file: "lifeconcept" },
  { name: "LinkRich", file: "linkrich" },
  { name: "Mac.Pan", file: "macpan" },
  { name: "Marana Forni", file: "marana-forni" },
  { name: "ROCAM", file: "rocam" },
  { name: "SAYL", file: "sayl" },
  { name: "BETTER", file: "better" },
  { name: "Sunmix", file: "sunmix" },
  { name: "DAZHENG", file: "dazheng" },
  { name: "TECNOMAC", file: "tecnomac" },
  { name: "Tognana", file: "tognana" },
  { name: "VALKO", file: "valko" },
];
